import { Autocomplete, Box, Button, MenuItem, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetBoxesQuery } from "src/_api/shipmentBox";
import BoxDialog from "../views/Boxes/components/BoxDialog";
import { pick } from "lodash";

export default function BoxesListSelect({ name, onChange, selectDefaultBoxAuto = true, boxValue }) {
    const { t } = useTranslation()
    const { data: boxes, isLoading } = useGetBoxesQuery({})

    const [box, setBox] = useState(null)

    useEffect(() => {
        if (boxes?.length > 0 && selectDefaultBoxAuto) {
            const defaultBox = boxes?.find(box => box.default) ?? boxes[0]
            setBox(defaultBox)
            onChange({ ...defaultBox?.dimensions })
        }
    }, [boxes, selectDefaultBoxAuto])

    //======= Box Dialog Handler =======
    const [open, setOpen] = useState(false)

    const openDialog = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setOpen(true)
    }

    const closeDialog = () => {
        setOpen(false)
    }

    useEffect(() => {
        if (!!boxValue) {
            const isAllPropertiesNull = (obj) => {
                return Object.values(obj).every(value => {
                    if (value && typeof value === 'object') {
                        return isAllPropertiesNull(value);
                    }
                    return !value;
                });
            };

            if (isAllPropertiesNull(boxValue?.dimensions)) {
                setBox(null)
            }
        }
    }, [boxValue])

    return (
        <Box display="flex" flexDirection="column">
            <Typography variant="subtitle1">{t("Box Type")}</Typography>
            <Autocomplete
                name={name}
                value={box}
                options={boxes ?? []}
                getOptionLabel={(option) => option.boxName}
                renderInput={(params) => <TextField {...params} />}
                //isOptionEqualToValue={(option, value) => option.id === value.id}
                renderOption={(props, option) => (
                    <MenuItem
                        {...props}
                        key={option.id}
                    >
                        {option.boxName}
                    </MenuItem>
                )}
                ListboxComponent={({ children, ...props }) => {
                    return <Box {...props}>
                        <Button sx={{ textTransform: "none" }} fullWidth onClick={openDialog}>{t("Add a new box type")}</Button>
                        {children}
                    </Box>
                }}
                onChange={(e, newValue) => {
                    setBox(newValue)
                    if (newValue) {
                        onChange(pick(newValue, ['dimensions', 'weight']))
                    }
                }}
                fullWidth
                size="small"
                loading={false}
            />
            <BoxDialog open={open} onClose={closeDialog} />
        </Box>
    )
}
